import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MoqsDiscountDetail from './components/MoqsDiscountDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageMoqsDiscount',
  components: {
    MoqsDiscountDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;